import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn } from '@angular/router';
import { PdcGuardService } from './pdc-guard.service';

export const canDeactivatePdc: CanDeactivateFn<any> = (component: any, route: ActivatedRouteSnapshot) => {
  return inject(PdcGuardService).canDeactivate(route);
};
